/*
 * Copyright (c) 2018.  Spin in het Web BV Apeldoorn
 * Geen toestemming zonder gebruik zonder schriftelijke overeenkomst
 * Ook bij schriftelijke overeenkomst is het gebruik van deze code
 * beperkt tot de in de overeenkomst opgenomen voorwaarden.
 */

/**
 * SPIN IN HET WEB APELDOORN
 * User: Jelmer Jellema
 * Date: 4-12-2017
 * Time: 17:08
 */


angular.module('sihw.datatable', ['sihw.angular.config', 'sihw.sihwlog', 'ngSanitize'])
    .factory('_datatable_global_svc', ['$rootScope', 'sihwAngularConfig', 'sihwlog',
        function ($rootScope, sihwAngularConfig, sihwlog) {
            //globale service voor het async watchen en vullen van de data, zodat het niet uit de hand loopt
            //een datatable hoeft alleen zijn $scope te registreren en $scope.checkIndata wordt aangeroepen
            //die returnt of er iets gewijzigd is
            //daarnaast gebruikt de datatable directive de vulqueue van de service om te zorgen dat als er meerdere tegelijk vullen, dit keurig om en om gebeurt

            let log = sihwlog.logLevel(sihwAngularConfig.loglevel('datatable'));
            log.debug('_datatable_global_svc init');
            let tables = []; //bevat een object met de scopes van een table. $scope.checkIndata wordt aangeroepen. Die moet true teruggeven als zijn data is gewijzigd, anders false
            let vulqueue = [];
            let vulqueuerunner = null;

            let watchTimeout = null;
            let watchCount = 0;

            //we gebruiken niet $timeout, want die doet een apply...
            function checkChecks(binnenDigest) {
                watchCount = 0; //want we hebben nu gecheckt

                let gewijzigd = false;
                for (let table of tables) {
                    gewijzigd = table.checkIndata() || gewijzigd; //de check links van de ||, zodat elke tabel checkt
                }
                if (gewijzigd) {
                    if (binnenDigest) {
                        //ook dan plannen we een nieuwe digest in, want het gaat soms mis met ng-repeat, die niet opnieuw checkt?
                        setTimeout(function () {
                            $rootScope.$digest()
                        });
                    } else {
                        $rootScope.$digest(); //nu dus wel
                    }
                }
            }

            $rootScope.$watch(function () {
                //dit runt bij elke digest.
                //wij laten de tables async checken of er iets gewijzigd is in de indata
                //zodat het niet de hele tijd gebeurt

                if (!tables.length) {
                    return;
                }
                if (watchTimeout) {
                    clearTimeout(watchTimeout);
                    watchTimeout = null;
                }

                //max watchcount niet te laag
                if (watchCount > 15) {
                    //dit duurde te lang - nu checken
                    checkChecks(true); //we zijn in een digest
                } else {
                    //anders kijken of we zo de tijd krijgen
                    watchCount++;
                    watchTimeout = setTimeout(function () {
                        checkChecks(false);
                    }, 50);
                }
            });

            /**
             * Run 1 element van de vulqueue, via de timeout. Daarna een volgende
             */
            function doeVulqueue() {
                //uitvoeren als de table er nog is
                let runnen = vulqueue.shift();
                //check of de table er nog is
                if (runnen && tables.includes(runnen.table)) {
                    runnen.fn();
                    $rootScope.$digest(); //digesten maar
                }
                //nieuwe timeout als er nog een queue is
                vulqueuerunner = vulqueue.length ?
                    setTimeout(doeVulqueue, 1)
                    : null;
            }


            //de service
            return {
                register: function (tableScope) {
                    tables.push(tableScope);
                    tableScope.$on('$destroy', function () {
                        tables = tables.filter(table => table !== tableScope);
                    });
                },

                /**
                 * Queue een vulfunctie via de vulfunctieloop. Doet niets anders dan $timeout, alleen dan goed verdeeld over de tabellen
                 * @param tableScope de $scope van de table
                 * @param fn de vulfunctie
                 */
                queueVulfunctie(tableScope, fn) {
                    vulqueue.push({table: tableScope, fn: fn});
                    if (!vulqueuerunner) {
                        vulqueuerunner = setTimeout(doeVulqueue, 1);
                    }
                }
            }

        }])
    .directive('datatable', ['$sce', '$timeout', 'sihwAngularConfig', 'sihwlog', '_datatable_global_svc',
        function ($sce, $timeout, sihwAngularConfig, sihwlog, _datatable_global_svc) {
            let log = sihwlog.logLevel(sihwAngularConfig.loglevel('datatable'));
            log.debug('datatable directive');

            let opties = sihwAngularConfig.opties('datatable');
            return {
                restrict: 'A',
                scope: {
                    //we doen oneway, want toch een eigen watch op inhoud
                    def: '< datatable', //de definitie
                    indata: '< datatableData',
                    rijklik: '& datatableRijklik', //functie met als eerste argument "rij" - bewerkbaar!
                    contextmenu: '< datatableContextmenu',
                    rijtitle: '& datatableRijtitle',
                    api: '=?'
                },
                //template onderaan
                link: function ($scope, el, attr) {

                    _datatable_global_svc.register($scope);
                    let datageneratie = 0; //voor asynchroon toepassen van data
                    let loading = false; //true tijdens vullen van data
                    let sorteerveld = null; //veldnaam waarop gesorteerd wordt. Object, wordt wel goed bijgehouden
                    let velden = {}; //de velden op key
                    let lognaam = "-"; //naam voor loggen,kan in def gezet worden


                    $scope.filteroptions = {
                        debounce: 400 //ms voordat een invoer in een filter verwerkt wordt
                    };
                    $scope.velden = [];
                    $scope.toonfilter = true; //toon filter
                    $scope.filterOpVerzoek = false;
                    $scope.filter = {}; //waar wordt op gefilterd
                    let vorigefilter = {}; //in plaats van previousvalue, omdat we soms het filteren uitstellen

                    let filterchain = []; //gegenereerde filterfuncties om toe te passen

                    let data = []; //binnenkomende data, maar encapsulated in een object {data:<data>} en metagegevens
                    $scope.data = []; //de uiteindelijk af te beelden data, na filteren

                    //sticken we de header in een scrollparent?
                    let scrollparent, scroller;
                    if (scrollparent = attr.scrollparent || attr['data-scrollparent']) {
                        scroller = el.closest(scrollparent);
                        if (scroller && scroller.length) {
                            $timeout(function () {
                                //even laten initialiseren
                                let headers = el.find('.stickyheader'); //nu pas ophalen, zodat het er is
                                scroller.on('scroll', function () {
                                    if (scroller[0].scrollTop) {
                                        headers.css({transform: `translateY(${scroller[0].scrollTop}px)`});
                                    } else {
                                        headers.css('transform', ""); //weg, want headers wordt een containing block als er een transform op staat (https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block)
                                    }
                                });
                            }, 100);
                        } else {
                            log.error('scrollparent niet gevonden');
                        }
                    }

                    //parse de scopevars, zodat we minder digests pakken
                    $scope.$watch('api', initApi);
                    $scope.$watch('def', defChanged, true);
                    $scope.$watch('filter', function () {
                        //zonder watcher  gewoon direct
                        filterChanged();
                    }, true); //update de data bij wijzigen filter

                    //wijzigingen van indata checken we via de service runner

                    let watchTimeout = null;
                    let watchCount = 0;
                    let prevobj = null;

                    //check de indata als de service dat wil
                    $scope.checkIndata = function () {

                        //deep equals, dus we mogen *niets* met objectidentity doen
                        //op props van de data zelf wijzigen mag niet (als in $selecteer e.d.)

                        let gelijk = angular.equals(prevobj, $scope.indata); //deep, want prevobj is altijd een kopie
                        if (!gelijk) {
                            prevobj = angular.copy($scope.indata); //nu pas kopiëren
                            indataChanged();
                        }
                        return !gelijk;
                    };

                    /**
                     * Init een scope var met api-functies
                     */
                    function initApi() {
                        log.debug(`***datatable ${lognaam} init Api`);
                        if (!$scope.api) {
                            $scope.api = {};
                        }

                        /**
                         * Geef geselecteerde data terug
                         */
                        $scope.api.geselecteerd = function () {
                            if (!$scope.selecteer) {
                                return [];
                            }

                            //geef rijen terug die nu geselecteerd zijn, en als filterSelect true, ook nu zichtbaar zijn
                            return data.filter(rij => rij.selecteerbaar && rij.geselecteerd && ($scope.selecteer.filterSelect === false || rij.infilter)).map(rij => rij.data);
                        };

                        /**
                         * Selecteer of deseleteer een rij. Let op, deze rij moet er al zijn en dat kan even duren ivm scoping. Gebruik eventueel api.geladen.
                         * @param rijOfTracker Een hele rij (op object-identity) of een id
                         * @param {boolean} selecteer
                         * @returns {undefined | boolean} De nieuwe selectiestatus, of undefined als de rij er niet is, of selectiemodus uitstaat
                         */
                        $scope.api.selecteer = function (rijOfTracker, selecteer) {
                            if (!(data && $scope.selecteer)) {
                                //is er sowieso niet
                                return undefined;
                            }

                            let rij;
                            if (angular.isObject(rijOfTracker)) {
                                rij = data.find(rij => rij.data === rijOfTracker);
                            } else if ($scope.tracker) {
                                rij = data.find(rij => rij.data[$scope.tracker] === rijOfTracker);
                            }
                            if (!rij) {
                                log.debug('api.selecteer: item niet gevonden');
                                return undefined;
                            }

                            //we zetten sowieso de selectie, ook als hij niet in filter zichtbaar is
                            return (rij.geselecteerd = selecteer);
                        };

                        /**
                         * Geef van een rij of de trackerid terug of hij geselecteerd is
                         * @param rijOfTracker
                         */
                        $scope.api.isGeselecteerd = function (rijOfTracker) {
                            if (!(data && $scope.selecteer)) {
                                //is er sowieso niet
                                return false;
                            }

                            let rij;
                            if (angular.isObject(rijOfTracker)) {
                                rij = data.find(rij => rij.data === rijOfTracker);
                            } else if ($scope.tracker) {
                                rij = data.find(rij => rij.data[$scope.tracker] === rijOfTracker);
                            }
                            if (!rij) {
                                log.debug('api.isGeselecteerd: item niet gevonden');
                                return false;
                            }

                            return rij.geselecteerd;
                        }
                        /**
                         * Geef gefilterde data terug
                         */
                        $scope.api.inFilter = function () {
                            return data.filter(rij => rij.infilter).map(rij => rij.data);
                        };

                        /**
                         * Pas het filter toe via de api, als we in de definitie filterOpVerzoek op true hebben staan
                         */
                        $scope.api.filterToepassen = function () {
                            filterChanged(true); //via api
                        };

                        /**
                         * Reset selectie en filter
                         */
                        $scope.api.reset = function () {
                            if ((data && $scope.selecteer)) {
                                //reset deselectie
                                for (let rij of data.filter(rij => rij.geselecteerd)) {
                                    rij.geselecteerd = false;
                                }
                            }
                            let filtergewijzigd = false;
                            for (let k of Object.keys($scope.filter)) {
                                if (!($scope.filter[k] === null || $scope.filter[k] === undefined)) {
                                    $scope.filter[k] = null;
                                    filtergewijzigd = true;
                                }
                            }
                            if (filtergewijzigd) {
                                filterChanged(true); //nu nietmeer
                            }
                        };
                    }

                    /**
                     * Genereer de veldinfo wanneer de velddefinitie wordt gewijzigd (en bij init)
                     */
                    function defChanged(nieuw, oud) {
                        if (oud) {
                            log.debug(`*** Datatable ${lognaam} def changed`, oud, nieuw);
                        }
                        $scope.velden = [];
                        $scope.tracker = $scope.def && $scope.def.track || false;
                        $scope.groepen = []; //zijn er groepen?
                        velden = {}; //voor intern gebruik, veld op key
                        //dit betekent ook resetten van filter en sortering
                        sorteerveld = null;
                        $scope.filter = {};
                        filterchain = []; //dus deze ook leeg

                        //lognaam
                        lognaam = $scope.def && $scope.def.lognaam || '-';

                        //filter?
                        $scope.toonfilter = $scope.def && ((!('filter' in $scope.def)) || $scope.def.filter); //default true
                        $scope.filterOpVerzoek = $scope.def && $scope.def.filterOpVerzoek; //default false

                        //paar standaardfuncties in de functies van de templatevelden

                        let standaardformat = function (rij) {
                            return this.html ? $sce.trustAsHtml(rij._val[this.key]) : rij._val[this.key];
                        };

                        let standaardstyle = function (rij) {
                            return ''; //niets
                        };


                        let standaardsortval = function (rij) {
                            let formatted = rij.format[this.key]; //kan $sce zijn
                            if (formatted === null) {
                                return formatted;
                            }
                            if (this.html) {
                                //$sce?
                                try {
                                    formatted = formatted.valueOf(); //als er een value-of is, dan nemen we die
                                } catch (_e) {
                                }
                                if (formatted) {
                                    //haal html eraf
                                    formatted = $('<div/>').html(formatted).text();
                                }
                            }
                            formatted = String(formatted).toLowerCase();
                            return formatted;
                        };

                        //standaard hetzelfde als sortval
                        let standaardfilterval = function (rij) {
                            return getCached(this, rij, 'sortval');
                        };

                        //we moeten sorteerveld opnieuw instellen, als die er was
                        let sorteerkey = sorteerveld && sorteerveld.key;
                        let sorteerrichting = sorteerveld && sorteerveld.sortering;
                        sorteerveld = null; //nu legen


                        //de velden
                        let huidige_groep = {};
                        let heeftgroepen = false;
                        angular.forEach($scope.def && $scope.def.velden ? $scope.def.velden : [], function (velddef, veld) {
                            if (velddef.hide) {
                                return; //verder
                            }
                            //groep?
                            if (velddef.groep) {
                                heeftgroepen = true;
                                if (huidige_groep && huidige_groep.label === velddef.groep) {
                                    huidige_groep.cols++;
                                    velden[huidige_groep.velden[huidige_groep.velden.length - 1]].groep_laatste = false; //want dat is nu deze
                                    huidige_groep.velden.push(veld);
                                } else {
                                    huidige_groep = {
                                        label: velddef.groep,
                                        velden: [veld],
                                        cols: 1
                                    };
                                    $scope.groepen.push(huidige_groep);
                                }
                            } else {
                                //geen groep
                                huidige_groep = false;
                                $scope.groepen.push(false); //een geen-groep
                            }

                            $scope.filter[veld] = $scope.filter[veld] || angular.copy(velddef.standaardfilter || null); //kopie ivm wijzing in ux keurig op standaard, maar zie verderop. Als er een filter is, dan gaat dat voor
                            let parsed = {
                                key: veld,
                                groep: huidige_groep, //meteen alle info
                                groep_eerste: huidige_groep && huidige_groep.cols === 1,
                                groep_laatste: !!huidige_groep, //vooralsnog wel, wordt hierboven gecorrigeerd
                                label: ('label' in velddef) ? velddef.label : veld,
                                filter: ('filter' in velddef) ? velddef.filter : true,
                                prop: (velddef.prop || veld).split('.'), //array, bijv [project,klant,naam]
                                sortering: 0, //1 = sorteer asc, -1 = desc
                                filtertype: 'vrij', //filter gebruikt standaard vrije invoer - zie switch hieronder bij bepalen type
                                //defaults:
                                //_val, de functie die de basiswaarde bepaalt, wordt hieronder gezet
                                format: standaardformat, //functie voor teruggeven geformatteerde waarde gegeven een rij  (standaard: de waarde)
                                style: standaardstyle, //functie voor het teruggeven van ngStyle-entrie gegeven een rij (standaard: niets)
                                sortval: standaardsortval, //functie voor teruggeven waarde tbv sorteren gegeven een rij (standaard: hetzelfde als format)
                                filterval: standaardfilterval,
                                classes: null //functie voor teruggeven een class of array van classes gegeven een rij (standaard: niets)
                            };


                            //sortering?
                            if (sorteerkey === veld) {
                                //dit is dezelfde, maar een nieuw object. Overnemen
                                parsed.sortering = sorteerrichting;
                                sorteerveld = parsed; //deze dus
                            }

                            parsed._val = function (rij) {
                                let cur = rij.data;
                                let prop;
                                for (let i = 0, _l = this.prop.length; i < _l; i++) {
                                    prop = this.prop[i];
                                    if (cur !== null && angular.isObject(cur) && (prop in cur)) {
                                        cur = cur[prop];
                                    } else {
                                        cur = null;
                                        break;
                                    }
                                }
                                return cur;
                            };

                            //het type
                            if (!('type' in velddef)) {
                                parsed.type = 'string';
                                parsed.typeArgs = {};
                            } else {
                                if (angular.isArray(velddef.type)) {
                                    //dan is [0] het type en [1] een propsobject (of undefined)
                                    parsed.type = velddef.type[0]; //dat is er maar eentje
                                    parsed.typeArgs = velddef.type[1] || {};
                                } else {
                                    parsed.type = velddef.type;
                                    parsed.typeArgs = {};
                                }
                            }

                            switch (parsed.type) {
                                case 'string':
                                    //alles standaard, behalve format, als er een max-length is
                                    if (parsed.typeArgs.maxlength) {
                                        if (velddef.html) {
                                            log.warn(`Datatable ${lognaam}: veld ${veld} heeft maxlength én html. Dat gaat niet samen.`);
                                        } else {
                                            parsed.format = function (rij) {
                                                let res = rij._val[this.key];
                                                if (res && res.length > this.typeArgs.maxlength) {
                                                    res = res.substr(0, this.typeArgs.maxlength) + '...'
                                                }
                                                return res;
                                            }
                                        }
                                    }
                                    break;
                                case 'moment':
                                    //een momentjs-moment of iets dat daarin parst
                                    //args kan format bevatten, anders gewoon momentjs format
                                    //en ook filtertype 'datum' voor de datumpicker
                                    parsed.html = false; //tenzij dat zo bij custom weer true wordt
                                    parsed.format = function (rij) {
                                        let m = moment(rij._val[this.key]);
                                        return (m.isValid()) ? m.format(this.typeArgs.format) : "";  //kan undef zijn
                                    };
                                    parsed.sortval = function (rij) {
                                        let v = rij._val[this.key];
                                        if (!v) {
                                            return "";
                                        }

                                        return moment(v).valueOf();
                                    };
                                    //filteren
                                    if (parsed.typeArgs.filtertype === "datum") {
                                        parsed.filtertype = 'datum';
                                        parsed.filterval = function (rij) {
                                            return rij._val[this.key] ? moment(rij._val[this.key]).format("YYYY-MM-DD") : null;
                                        }
                                    } else {
                                        //filteren op geformateerde versie
                                        parsed.filterval = function (rij) {
                                            return rij.format[this.key];
                                        };

                                        parsed.filtertype = 'vrij'; //gewoon vrij
                                    }
                                    break;
                                case 'bool':
                                    //boolean: geen veldwaarde, alleen classes\
                                    parsed.format = null;
                                    parsed.html = false; //tenzij dat zo bij custom weer true wordt
                                    parsed.classes = function (rij) {
                                        if (this.format) {
                                            return null; //dan eigen inhoud
                                        }
                                        return ['glyphicon',
                                            rij._val[this.key] ?
                                                'glyphicon-ok'
                                                :
                                                'glyphicon-remove'
                                        ];
                                    };
                                    parsed.filtertype = 'bool'; //boolfilter
                                    parsed.sortval = function (rij) {
                                        return rij._val[this.key] ? 1 : -1;
                                    };

                                    break;
                                case 'enum':
                                    parsed.html = false; //gewoon niet
                                    parsed.filtertype = 'enum'; //apart filter
                                    //verder de defaults
                                    break;
                                case 'multi':
                                    //multiselect
                                    parsed.html = false; //gewoon niet
                                    parsed.filtertype = 'multi'; //ook apart
                                    break;
                                case 'int':
                                case 'float':
                                    parsed.html = false; //tenzij dat zo bij custom weer true wordt
                                    if (parsed.type === 'int') {
                                        parsed.sortval = function (rij) {
                                            return Number.parseInt(rij._val[this.key], 10) || 0
                                        };
                                    } else if (parsed.type === 'float') {
                                        parsed.format = function (rij) {
                                            //altijd de scheiding goedzetten
                                            let decimaalveld = opties.decimaalscheider || ',';
                                            let strval = this.sortval(rij).toString().replace(/[,.]/, decimaalveld);
                                            if ('fixed' in this.typeArgs) {
                                                //vast aantal cijfers achter de komma
                                                let fixed = parseInt(this.typeArgs.fixed);
                                                if ((!isNaN(fixed)) && fixed >= 0) {
                                                    let geheel, decimalen;
                                                    [geheel, decimalen] = strval.split(decimaalveld, 2);
                                                    geheel = geheel || "0";
                                                    decimalen = decimalen || "";
                                                    let numdecimalen = decimalen ? decimalen.length : 0;
                                                    if (numdecimalen < fixed) {
                                                        decimalen += "".padEnd(fixed - numdecimalen, '0');
                                                    } else if (numdecimalen > fixed) {
                                                        //hakken
                                                        decimalen = decimalen.substr(0, maxdecimalen);
                                                    }
                                                    strval = `${geheel}${decimaalveld}${decimalen}`;
                                                }
                                            }
                                            return strval;
                                        };
                                        parsed.sortval = function (rij) {
                                            return Number.parseFloat(rij._val[this.key]) || 0
                                        };
                                    }

                                    //filteren
                                    if (parsed.typeArgs.filtertype === "vantot") {
                                        parsed.filtertype = 'vantot';
                                        //filterval is dan numeriek, zie hierboven
                                    } else {
                                        parsed.filtertype = "vrij";
                                        parsed.filterval = function (rij) {
                                            return String(rij._val[this.key]);
                                        };
                                    }
                                    break;
                                case 'format':
                                    //eigen format op basis van een hele rij. Moet een format-functie hebben met alleen de rij als argument
                                    parsed._val = null; //niet nodig
                                    parsed.html = velddef.html;
                                    parsed.format = function (rij) {
                                        //html mag erin
                                        let formatted = velddef.format(rij.data);
                                        return this.html ? $sce.trustAsHtml(formatted) : formatted;
                                    };
                                    break;
                                default:
                                    //de defaults
                                    parsed.html = velddef.html;
                                    break;
                            }

                            //custom format?
                            if (velddef.format && (parsed.type !== 'format')) //bij format is hij al gezet
                            {
                                parsed.html = velddef.html; //dit overschrijft de setting per type dan weer
                                parsed.format = function (rij) {
                                    //html mag erin
                                    let formatted = velddef.format(rij._val[this.key], rij.data);
                                    return this.html ? $sce.trustAsHtml(formatted) : formatted;
                                }
                            }

                            //custom styles
                            if (velddef.style) {
                                parsed.style = function (rij) {
                                    return velddef.style(rij._val[this.key], rij.data);
                                }
                            }

                            //afwijkende sortval?
                            if (velddef.sortval && typeof (velddef.sortval) === "function") {
                                parsed.sortval = function (rij) {
                                    return velddef.sortval(rij._val[this.key], rij.data);
                                };
                            }

                            //afwijkende filterval?
                            if (velddef.filterval && typeof (velddef.filterval) === "function") {
                                parsed.filterval = function (rij) {
                                    return velddef.filterval(rij._val[this.key], rij.data);
                                };
                            }


                            //geen filter?
                            if (!parsed.filter) {
                                parsed.filtertype = 'hide';
                            }


                            $scope.velden.push(parsed);
                            velden[veld] = parsed; //ook voor intern gebruik op key
                        });

                        //tweede loop, als de groepen goed staan etc.
                        for (let parsed of $scope.velden) {
                            //cellclasses
                            let tdclasses = [`datatable_${parsed.key}`, `datatableveld_veldtype_${parsed.type}`];
                            if (parsed.groep) {
                                tdclasses.push('datatableveld_ingroep');
                                if (parsed.groep_eerste) {
                                    tdclasses.push('datatableveld_groep_eerste');
                                }
                                if (parsed.groep_laatste) {
                                    tdclasses.push('datatableveld_groep_laatste');
                                }
                            }
                            parsed.tdclasses = tdclasses.join(" ");
                        }
                        //groepen:
                        if (!heeftgroepen) {
                            $scope.groepen = false; //weg ermee
                        }

                        //selecteerbaar?
                        if ($scope.def && $scope.def.selecteer) {
                            $scope.selecteer = {
                                label: $scope.def.selecteer.label || "",
                                selecteerallesknop: ('allesknop' in $scope.def.selecteer) ? $scope.def.selecteer.allesknop : true,
                                setProp: $scope.def.selecteer.setProp || false, //indata-property voor zetten selectie
                                filterSelect: ('filterSelect' in $scope.def.selecteer) ? $scope.def.selecteer.filterSelect : true,
                                check: $scope.def.selecteer.selecteerbaar || function () {
                                    return true;
                                }
                            };
                            if ($scope.def.selecteer.prop) {
                                //OUD
                                log.warn(`Datatable ${lognaam}: let op: selecteren is gewijzigd. Niet meer met een prop of $select, maar via de api.geselecteerd()`);
                            }
                        } else {
                            $scope.selecteer = false;
                        }

                        //kiesbaar?
                        if ($scope.def && $scope.def.kies) {
                            $scope.kies = angular.extend({
                                label: '',
                                positie: 'beide',
                                content: {
                                    links: "<span class='glyphicon glyphicon-circle-arrow-right'></span>",
                                    rechts: "<span class='glyphicon glyphicon-circle-arrow-left'></span>"
                                },
                                class: 'btn btn-default',
                                kiesbaar: () => true,
                                kies: angular.noop
                            }, $scope.def.kies);
                            $scope.kies.links = $scope.kies.positie === 'links' || $scope.kies.positie === 'beide';
                            $scope.kies.rechts = $scope.kies.positie === 'rechts' || $scope.kies.positie === 'beide';
                        } else {
                            $scope.kies = false;
                        }

                        //oude property in de indata voor 'in filter'
                        //is niet meer, geen aanpassingen aan indata!
                        if ($scope.def && $scope.def.filterProp) {
                            log.warn(`Datatable ${lognaam}: let op: filterProp is gewijzigd. Niet meer met een prop of $infilter, maar via de api.inFilter()`);
                        }

                        //we moeten de data opnieuw sorteren (op origvolgorde), opnieuw filteren en dan toepassen
                        bepaalEnumdata(); //bepaal de mogelijke waarden op enumfilters
                        sorteerData();
                        filterData();
                        toepassenData(true); //forceer reload
                    }

                    /**
                     * Binnenkomende data is gewijzigd. We kopiëren het opnieuw en sorteren het
                     */
                    function indataChanged() {
                        //opnieuw setten van de data, herfilteren, hersorteren en tonen
                        //we maken geen kopie, maar encapsuleren de live data in een object waarin ook metadata zit
                        //rijclasses?
                        let rijclassfn = ($scope.def && (typeof ($scope.def.rijclasses) === 'function')) ? $scope.def.rijclasses : null;

                        let i = 0;
                        let prevdata = data || []; //even de oude
                        data = ($scope.indata || []).map(function (rijdata) {
                            //hebben we een oude meta voor dezelfde data?
                            let oud = prevdata.find(rij =>
                                rij.data === rijdata ||
                                ($scope.tracker && rij.data[$scope.tracker] === rijdata[$scope.tracker]));

                            let rij = {
                                data: rijdata,
                                infilter: true, //eerst, moeten we opnieuw bepalen
                                //geselecteerd: bewaar de selectie, maar bij een nieuwe rij kan hij geselecteerd worden door de setProp-optie
                                geselecteerd: oud ? oud.geselecteerd : $scope.selecteer && $scope.selecteer.setProp && rijdata[$scope.selecteer.setProp],
                                origvolgorde: i++, //onthouden
                                //caches, zie getCached
                                _val: {},
                                style: {},
                                format: {},
                                sortval: {},
                                filterval: {},
                                classes: {},
                                rijclasses: rijclassfn && rijclassfn(rijdata),
                                rijtitle: $scope.rijtitle({rij: rijdata})
                            };
                            for (let veldkey of Object.keys(velden)) {
                                let veld = velden[veldkey];
                                //we cachen zaken die gegarandeerd nodig zijn
                                //die zijn er dus altijd
                                getCached(veld, rij, '_val');
                                getCached(veld, rij, 'format'); //stop het in de cache
                                getCached(veld, rij, 'style'); //stop het in de cache
                                getCached(veld, rij, 'classes'); //meteen ook clases
                                rij.selecteerbaar = $scope.selecteer && $scope.selecteer.check(rij.data); //selecteerbaar?
                                rij.kiesbaar = $scope.kies && $scope.kies.kiesbaar(rij.data); //kiesbaar?
                            }
                            return rij;
                        });

                        bepaalEnumdata(); //bepaal de mogelijke waarden op enumfilters
                        sorteerData();
                        filterChanged(true); //afdwingen, als de data gewijzigd is
                        toepassenData(false); //geen forceerreload
                    }

                    /**
                     * Bepaal de mogelijke waarden van velden met een enumfilter
                     */
                    function bepaalEnumdata() {
                        if (!$scope.toonfilter) {
                            return; //hoeft dus niet
                        }
                        //we gebruiken nog geen Set om het unique te krijgen

                        angular.forEach(velden, function (veld) {
                            if (veld.filtertype === 'enum' || veld.filtertype === 'multi') {
                                veld.filteropties = [];
                                let checkdubbel = {};
                                angular.forEach(data, function (rij) {
                                    let val = veld.format(rij) || "";
                                    if (!checkdubbel[val.toLowerCase()]) {
                                        veld.filteropties.push(val);
                                        checkdubbel[val.toLowerCase()] = true;
                                    }
                                });
                                if ($scope.filter[veld.key]) {
                                    let checkvals = Array.isArray($scope.filter[veld.key]) ? $scope.filter[veld.key] : [$scope.filter[veld.key]];
                                    for (let val of checkvals) {
                                        if (!checkdubbel[val.toLowerCase()]) {
                                            veld.filteropties.push(val);
                                            checkdubbel[val.toLowerCase()] = true;
                                        }
                                    }
                                }
                                //en dan nog de expliciet toegevoegde
                                if (veld.typeArgs && veld.typeArgs.values && Array.isArray(veld.typeArgs.values)) {
                                    for (let val of veld.typeArgs.values) {
                                        if (!checkdubbel[val.toLowerCase()]) {
                                            veld.filteropties.push(val);
                                            checkdubbel[val.toLowerCase()] = true;
                                        }
                                    }
                                }
                                veld.filteropties.sort();
                            }
                        });
                    }

                    /**
                     * Filter is gewijzigd. Hetgenereer de filterchain, opnieuw filteren, tonen en eventueel melden. Sortering wijzigt niet
                     */
                    function filterChanged(viaApi) {
                        //bepaal hoe we filteren
                        //$scope.filter bevat als keys de veldkeys, en als value te matchen waardes. Maar het type doet er wel toe
                        //we loopen over de veldkeys in het filter en maken een functie die, gegeven de rij, true of false teruggeeft
                        //deze gaan in de filterchain. De functies worden voor elke rij aangeroepen en moeten allemaal slagen om in het filter terecht te komen

                        if ($scope.def && $scope.def.filterOpVerzoek && (!viaApi)) {
                            return; //dan doen we nog niets, pas als dit via de api wordt gevraagd
                        }


                        filterchain = []; //reset
                        angular.forEach($scope.filter, function (val, veldkey) {
                            if (val === null || val === undefined) {
                                return; //niet nodig
                            }
                            var veld = velden[veldkey];
                            var fn = false; //als dit false blijft hoeft er voor dit filteritem geen functie worden uitgevoerd
                            switch (veld.filtertype) {
                                case 'vrij':
                                    if (val === "") {
                                        break; //geen test nodig
                                    }
                                    fn = function (rij) {
                                        //return true als er een substringmatch is
                                        let filterval = getCached(veld, rij, 'filterval');
                                        if (filterval === null) {
                                            filterval = "";
                                        }
                                        return String(filterval).includes(val.toLowerCase());
                                    };
                                    break;
                                case 'enum':
                                    fn = function (rij) {
                                        //bijna als vrij, alleen dan exacte match
                                        //testen op null gebeurt al hierboven buiten deze switch
                                        return getCached(veld, rij, 'filterval') === val.toLowerCase();
                                    };
                                    break;
                                case 'multi':
                                    if (!(Array.isArray(val) && val.length)) {
                                        break; //geen test nodig
                                    }
                                    //filterval is al lowercase gemaakt?
                                    fn = function (rij) {
                                        //exacte match in de geselecteerde waarden
                                        return val.includes(getCached(veld, rij, 'filterval'));
                                    };
                                    break;
                                case 'bool':
                                    if (!val) {
                                        break; //niet te doen, geen functie nodig
                                    }
                                    fn = function (rij) {
                                        return (rij._val[veld.key] ? 1 : 2) === val;
                                    };
                                    break;
                                case 'datum':
                                    //via de datumpicker
                                    if (!(val && (val.van || val.tot))) {
                                        break; //niets te doen
                                    }
                                    fn = function (rij) {
                                        let fv = getCached(veld, rij, 'filterval');
                                        return fv && ((!val.van) || val.van <= fv) && ((!val.tot) || val.tot >= fv);
                                    };
                                    break;
                                case 'vantot':
                                    //via decimaalveldpicker
                                    if ((!val) || (val.van === null && val.tot === null)) {
                                        break; //niets te doen
                                    }
                                    fn = function (rij) {
                                        //filterval is al numeriek
                                        let fv = getCached(veld, rij, 'filterval');
                                        return (fv !== null) && ((val.van === null) || val.van <= fv) && ((val.tot === null) || val.tot >= fv);
                                    };
                                    break;
                                case 'hide':
                                    break; //doe niets
                                default:
                                    fn = function () {
                                        log.warn(`Datatable ${lognaam}: missende filterfunctie voor filtertype`, veld.filtertype, veld.key, val);
                                    };
                                    break;
                            }
                            if (fn) {
                                filterchain.push(fn);
                            }
                        });

                        //wil de client iets met een gewijzigd filter?
                        //dan melden we dat, maar we gaan voor het betere effect zelf wel door met vullen

                        if ($scope.def && (typeof $scope.def.onFilterChanged === "function")) {
                            let vorige = vorigefilter || {};
                            let gewijzigd = {}; //gewijzigde velden
                            let wijzigingen = false;
                            for (let veldkey of Object.keys(velden)) {
                                let veld = velden[veldkey];
                                let infilter = (veldkey in $scope.filter) && ($scope.filter[veldkey] !== null);
                                let inprev = (veldkey in vorige) && (vorige[veldkey] !== null);
                                if (infilter !== inprev ||
                                    (
                                        infilter && !angular.equals($scope.filter[veldkey], vorige[veldkey])
                                    )
                                ) {
                                    //deze geldt als gewijzigd
                                    gewijzigd[veldkey] = [angular.copy($scope.filter[veldkey]), angular.copy(vorige[veldkey])]; //array met nieuw, oud
                                    wijzigingen = true;
                                }
                            }
                            if (wijzigingen) {
                                //we moeten aanroepen
                                try {
                                    $scope.def.onFilterChanged(gewijzigd);
                                } catch (e) {
                                    log.warn(e);
                                }
                            }
                        }

                        //vorigefilter kan nu bijgewerkt worden
                        vorigefilter = angular.copy($scope.filter);

                        //maar hoe dan ook bijwerken, zat ziet er beter uit da wachten op nieuwe data

                        filterData();
                        toepassenData(); //opnieuw toepassen, want dit kan tijdens de oorspronkelijke vulloop gebeuren

                    }


                    //cacheing van format, sortval en filterval

                    /**
                     * Haal de formatted waarde op van een veld in deze rij, cached of via functie
                     * @param veld
                     * @param rij
                     * @param proces is '_val', 'format', 'style', 'classes', 'sortval' of 'filterval'
                     */
                    function getCached(veld, rij, proces) {
                        if (veld.key in rij[proces]) {
                            return rij[proces][veld.key]; //cached
                        } else {
                            return rij[proces][veld.key] = veld[proces] && veld[proces](rij);
                        }
                    }

                    $scope.getCached = getCached;


                    /**
                     * Sorteer de data opnieuw.
                     * Interne functie, wordt NIET automatisch toegepast (gebruik toepassendata)
                     */
                    function sorteerData() {
                        var sorteerop, sortering;
                        var opprop = false;

                        if (sorteerveld) {
                            sorteerop = sorteerveld;
                            sortering = sorteerveld.sortering || 1;
                        } else if ($scope.def && $scope.def.standaardsortering) {
                            if ($scope.def.standaardsortering.veld) {
                                sorteerop = velden[$scope.def.standaardsortering.veld];
                                sortering = ($scope.def.standaardsortering.richting || 1) < 0 ? -1 : 1;
                            } else if ($scope.def.standaardsortering.prop) {
                                //sorteren op een prop in de data, mag alleen op hoofdniveau
                                sorteerop = $scope.def.standaardsortering.prop;
                                sortering = ($scope.def.standaardsortering.richting || 1) < 0 ? -1 : 1;
                                opprop = true; //we werken met een property, niet met een heel veld
                            }
                        }

                        if (!sorteerop) //nog niets bedacht
                        {
                            //dan met de origvolgorde
                            data.sort(function (a, b) {
                                return (a.origvolgorde || 0) > (b.origvolgorde || 0) ? 1 : -1;
                            });
                            return;
                        }


                        if (opprop) {
                            //sorteer op hoofproperty
                            data.sort(function (a, b) {
                                let va = (a.data[sorteerop] || 0);
                                let vb = (b.data[sorteerop] || 0);
                                if (va > vb) {
                                    return sortering * 1;
                                } else if (va < vb) {
                                    return sortering * -1;
                                } else {
                                    //origvolgorde
                                    return sortering * ((a.origvolgorde || 0) > (b.origvolgorde || 0) ? 1 : -1);
                                }
                            });
                        } else {
                            //vergelijk de sorteerwaarden volgens dit veld
                            //en wijzig de richting als de sortering van het veld -1 is
                            data.sort(function (a, b) {
                                let va = getCached(sorteerop, a, 'sortval');
                                let vb = getCached(sorteerop, b, 'sortval');
                                if (va === null) {
                                    va = "";
                                }
                                if (vb === null) {
                                    vb = ""
                                }
                                if (va > vb) {
                                    return sortering * 1;
                                } else if (va < vb) {
                                    return sortering * -1;
                                } else {
                                    //origvolgorde
                                    return sortering * ((a.origvolgorde || 0) > (b.origvolgorde || 0) ? 1 : -1);
                                }
                            });
                        }
                    }

                    /**
                     * Maak nieuwe scopedata op basis van de interne data, gesorteerd en met filterflag
                     * @param {boolean} [forceer] Als true, dan behandelen we de data als nieuw en gaan we ervanuit dat ng-repeat niet snel kan werken met een hashkey (zie defChanged)
                     */
                    function toepassenData(forceer) {
                        datageneratie++;
                        if (!data) {
                            data = [];
                        }

                        //als we klaar zijn met laden en er komt nieuwe data, dan kunnen we snel handelen
                        //heuristiek: moet ongeveer net zoveel zijn
                        //ng-repeat werkt dan snel met zijn hashkey
                        if ((!forceer) && (!loading) && $scope.data && $scope.data.length && Math.abs($scope.data.length - data.length) < 10) {
                            $scope.data = data; //hopla
                            return;
                        }

                        loading = true; //we zijn nu aan het laden, gebruikt in logica rond filteren hieronder
                        //okee: druppelen met batches, voor de snelheid eerst alles dat uit het filter valt skippen

                        let onzegeneratie = datageneratie; //local closure
                        $scope.data = []; //deze gaan we vullen
                        let vuldata = data.filter(rij => rij.infilter);
                        let batch = 20;

                        naarscope(0, 15, vuldata.length !== data.length); //snel een paar en dit is mogelijk gefilterd

                        function naarscope(index, dezebatch, gefilterd) {
                            if (onzegeneratie !== datageneratie) {
                                return; //laat maar, nieuwe data, we blijven dan ook van 'loading' af
                            }

                            //we vullen een stukje
                            let laatste = index + dezebatch;
                            $scope.data.push(...vuldata.slice(index, laatste));
                            if (laatste < vuldata.length) {
                                //zometeen verder, via de queue in de service
                                _datatable_global_svc.queueVulfunctie($scope, function () {
                                    naarscope(laatste, batch, gefilterd);
                                }); //daarna meer
                            } else {
                                //okee, als dit alleen gefilterd was, gaan we nu alle ongefilterde er achter zetten. Als het goed is pakt ng-repeat dit aardig op door te herkennen wat er al staat
                                //daarna gaan we hersorteren
                                if (gefilterd) {
                                    vuldata = data.filter(rij => !rij.infilter);
                                    _datatable_global_svc.queueVulfunctie($scope, function () {
                                        naarscope(0, batch, false); //als in niet gefilterd
                                    });
                                } else {
                                    //sorteren en opnieuw vullen
                                    sorteerData(); //is dit nodig?
                                    $scope.data = data; //gaat snel, want de dom is er
                                    //en klaar met laden
                                    loading = false;
                                }
                                //check of we geen containerscroll moeten fixen
                                $timeout(checkContainerscroll, 10);
                                //en dan zo stripen
                                $timeout(stripe, 11);
                            }
                        }
                    }

                    /**
                     * Controleer of de scrollparent niet verder is gescrolled dan kan.
                     */
                    function checkContainerscroll() {
                        //check het scrollen als we een scrollparent hebben
                        //even opnieuw de scrollparent bepalen
                        if (scroller) {
                            //scroller is de scrollparent
                            //is die verder gescrolled dan kan?
                            let maxscroll = Math.max(el[0].offsetHeight - scroller[0].offsetHeight, 0);
                            if (scroller[0].scrollTop > maxscroll) {
                                scroller[0].scrollTop = maxscroll;
                            }
                        }
                    }

                    /**
                     * Pas het huidige filter toe op de data.
                     */
                    function filterData() {

                        //en loop over de volledige data, niet alleen $scope.data (want die is aanvankelijk gefilterd)
                        angular.forEach(data, function (rij) {
                            //bepaal of deze in filter zit
                            rij.infilter = filterchain.every(filterfn => filterfn(rij));
                        });
                        bepaalSelectie();
                        //check of we geen containerscroll moeten fixen
                        $timeout(checkContainerscroll, 10);
                        //en dan zo stripen
                        $timeout(stripe, 11);
                    }

                    /**
                     * Laat een veld gesorteerd worden
                     * @param veld
                     */
                    $scope.doesorteer = function (veld) {
                        //we slaan in sorteer de veldkey op, niet het object
                        //ivm digest-rondes op de scope
                        //bij desorteren zal sorteerData de oorspronkelijke sortering tonen
                        if (veld.sortering === 1) {
                            //werd al gesorteerd, nu andere kant
                            veld.sortering = -1;
                        } else if (veld.sortering === -1) {
                            //dan nu niets meer: oorspronkelijke sortering
                            veld.sortering = 0;
                            sorteerveld = null;
                        } else {
                            //het was een andere, die niet meer, en de nieuwe wel
                            if (sorteerveld) {
                                sorteerveld.sortering = 0;
                            }
                            sorteerveld = veld; //deze nu
                            veld.sortering = 1;
                        }
                        sorteerData(); //opnieuw sorteren
                        toepassenData(); //en opnieuw toepassen
                    };

                    /**
                     * Ren over de zichtbare rijen om ze te stripen
                     */
                    function stripe() {
                        let classes = ['datatable-oneven', 'datatable-even'];
                        $(el).find('tr.datatable_data:not(.ng-hide)').each((i, tr) => {
                            $(tr).removeClass(classes[0]).addClass(classes[1]);
                            classes.push(classes.shift());
                        });
                    }

                    $scope.doerijklik = function (rij) {
                        if (typeof ($scope.rijklik) === 'function') {
                            $scope.rijklik({rij: rij.data});
                        } else if ($scope.selecteer && rij.selecteerbaar) {
                            //dan gewoon select
                            rij.geselecteerd = !rij.geselecteerd;
                            bepaalSelectie();
                        } else if ($scope.kies && rij.kiesbaar) {
                            //dan maar kies
                            try {
                                $scope.kies.kies(rij.data); //uitvoeren
                            } catch (e) {
                                log.error(e);
                            }
                        }
                    };

                    /**
                     * Vang klik in selectieveld op
                     * @param rij
                     * @param $event
                     * @param wissel actief wisselen? (wel bij click in cel, niet bij click in checkbox)
                     */
                    $scope.selectClick = function (rij, $event, wissel) {
                        log.debug(`selectclick`);
                        if ($scope.selecteer && rij.selecteerbaar && wissel) {
                            rij.geselecteerd = !rij.geselecteerd;
                        }
                        bepaalSelectie();
                        $event.stopPropagation();
                    };

                    /**
                     * Vang klik in kiesknop op
                     * @param rij
                     * @param $event
                     */
                    $scope.kiesClick = function (rij, $event) {
                        log.debug(`kiesClick`);
                        $event.stopPropagation();
                        if ($scope.kies && rij.kiesbaar) {
                            try {
                                $scope.kies.kies(rij.data);
                            } catch (e) {
                                log.error(e);
                            }
                        }
                    };

                    /**
                     * Selecteer of deselecteer alles wat nu zichtbaar is. Van onzichtbaar blijven we af - hangt van selectFilter af of die aan of uit blijven
                     */
                    $scope.selecteerAlles = function () {
                        if (!$scope.selecteer) {
                            return;
                        }
                        let selecteer = !$scope.allesGeselecteerd;
                        for (let rij of data.filter(rij => rij.infilter && rij.selecteerbaar)) {
                            rij.geselecteerd = selecteer;
                        }
                        bepaalSelectie();
                    };

                    /**
                     * Bepaal of alles geselecteerd is of niet
                     * dit gaat alleen om wat er zichtbaar is
                     */
                    function bepaalSelectie() {
                        if (!($scope.selecteer && data && data.length)) {
                            $scope.allesGeselecteerd = false;
                        } else {
                            $scope.allesGeselecteerd = !(data.some(rij => rij.infilter && rij.selecteerbaar && (!rij.geselecteerd)));
                        }
                    }


                    //boolfilter: een filter met fa classes en klikbaar om te wisselen. Twee helper functies
                    /**
                     * Geef de classes terug voor de huidige filterinhoud van een boolfilter
                     * @param veld
                     */
                    $scope.boolfilter_classes = function (veld) {
                        switch ($scope.filter[veld.key]) {
                            case 1: //1 = ja
                                return "glyphicon glyphicon-ok"; // "fa fa-check-square-o";
                            case 2: //2 = nee
                                return "glyphicon glyphicon-remove"; //"fa fa-square-o";
                            default: //0 en niets is maakt niet uit
                                return "glyphicon glyphicon-option-horizontal"; //"fa fa-square";
                        }
                    };

                    /**
                     * Wijzig een boolfilter voor een veld
                     * @param veld
                     */
                    $scope.boolfilter_switch = function (veld) {
                        //het is keurig rouleren: 0 = onbepaald, 1 = ja, 2 = nee
                        if (($scope.filter[veld.key] = ($scope.filter[veld.key] || 0) + 1) > 2) {
                            $scope.filter[veld.key] = 0;
                        }
                    };
                },
                template:
                    `
<thead class="stickyheader">
<tr ng-if="groepen" class="datatable_groepen" style="user-select: none">
<th ng-if="selecteer"></th>
<th ng-repeat="groep in groepen track by $index" colspan="{{groep ? groep.cols : 1}}}">{{groep ? groep.label : ''}}</th>
</tr>
<tr class="datatable_koppen" style="user-select: none;">
    <th ng-if="kies && kies.links" class="datatable_kies">{{kies.label}}</th>
    <th ng-if="selecteer" class="datatable_selecteer">{{selecteer.label}}</th>
    <th ng-repeat="veld in velden" ng-class="['datatable_' + veld.key, 'datatableveld_veldtype_' + veld.type, {'datatableveld_ingroep': !! veld.groep, 'datatableveld_groep_eerste': veld.groep_eerste, 'datatableveld_groep_laatste': veld.groep_laatste}]"><span ng-if="veld.label" ng-click="doesorteer(veld)">{{veld.label || ""}}<span
            ng-show="veld.sortering === 1">&#x25b2;</span><span
            ng-show="veld.sortering === -1">&#x25bc;</span>
    </span>
    </th>
    <th ng-if="kies && kies.rechts" class="datatable_kies">{{kies.label}}</th>
</tr>
</thead>
<tbody class="datatable_tbody"><tr ng-if="toonfilter" class="datatable_filter stickyheader">
    <td ng-if="kies && kies.links">&nbsp;</td>
    <td ng-if="selecteer" class="datatable_selecteer"><button ng-if="selecteer.selecteerallesknop" class="datatable_selecteeralles" ng-click="selecteerAlles()"><span class="glyphicon" ng-class="{ 'glyphicon-remove': allesGeselecteerd, 'glyphicon-ok': ! allesGeselecteerd}"</button></td>
    <td ng-repeat="veld in velden" ng-class="['datatable_' + veld.key, 'datatableveld_veldtype_' + veld.type, 'datatableveld_filtertype_' + veld.filtertype, {'datatableveld_ingroep': !! veld.groep, 'datatableveld_groep_eerste': veld.groep_eerste, 'datatableveld_groep_laatste': veld.groep_laatste}]">
        <div ng-if="veld.filtertype === 'vrij'"
             class="form-group datatable_filter_vrij">
            <input title="{{veld.label}}" type="text"
                   ng-model="filter[veld.key]" ng-model-options="filteroptions"
                   class="form-control">
        </div>
        <div ng-if="veld.filtertype === 'bool'"
             class="form-group datatable_filter_bool"
             ng-click="boolfilter_switch(veld)">
            <span title="{{veld.label}}"
                 ng-class="boolfilter_classes(veld)"></span>
        </div>
        <div ng-if="veld.filtertype === 'enum'"
             class="form-group datatable_filter_enum">
            <select title="{{veld.label}}" class="form-control"
                    ng-model="filter[veld.key]">
                <option ng-value="null"></option>
                <option ng-repeat="item in veld.filteropties" ng-value="item">
                    {{item}}
                </option>
            </select>
        </div>
        <div ng-if="veld.filtertype === 'multi'" class="form-group datatable_filter_multi">
            <datatablemultipicker ng-model="filter[veld.key]" items="veld.filteropties"></datatablemultipicker>
        </div>
        <div ng-if="veld.filtertype === 'datum'">
            <datatabledatumpicker soort="veld.filtertype" ng-model="filter[veld.key]"></datatabledatumpicker>
        </div>
        <div ng-if="veld.filtertype === 'vantot'">
            <datatablevantotpicker soort="veld.filtertype" ng-model="filter[veld.key]"></datatablevantotpicker>
        </div>
    </td>
    <td ng-if="kies && kies.rechts">&nbsp;</td>
</tr>
<tr class="datatable_data" ng-repeat="rij in data track by (tracker ? rij.data[tracker] : $id(rij))" ng-click="doerijklik(rij)" ng-show="rij.infilter"
    sihwcontextmenu-id="{{contextmenu}}" sihwcontext="rij.data"
    sihwcontext-default="true" title="{{rij.rijtitle}}"
    ng-class="rij.rijclasses">
    <td ng-if="kies && kies.links" ng-class="datatable_kies"><a ng-if="rij.kiesbaar" ng-class="kies.class" ng-click="kiesClick(rij,$event)" ng-bind-html="kies.content.links || kies.content"></a></td>
    <td ng-if="selecteer" ng-class="datatable_selecteer" ng-click="selectClick(rij,$event,true)"><input ng-if="rij.selecteerbaar" type="checkbox" ng-click="selectClick(rij,$event,false)" ng-model="rij.geselecteerd"></td>
    <td ng-repeat="veld in velden" ng-class="veld.tdclasses" ng-style="rij.style[veld.key]"><span ng-class="rij.classes[veld.key]"
              ng-bind-html="rij.format[veld.key]"></span></td>
   <td ng-if="kies && kies.rechts" ng-class="datatable_kies"><a ng-if="rij.kiesbaar" ng-class="kies.class" ng-click="kiesClick(rij,$event)" ng-bind-html="kies.content.rechts || kies.content"></a></td>
</tr>
</tbody>
`
            }
                ;
        }])
    .directive('datatabledatumpicker', ['sihwAngularConfig', 'sihwlog', function (sihwAngularConfig, sihwlog) {
        //filter voor de datatable. Gebruikt sihw-datepicker en voor het format dus ook de sihwAngularConfig datepicker opties
        //verwacht wel bootstrap
        let log = sihwlog.logLevel(sihwAngularConfig.loglevel('datatable'));
        log.debug('datatabledatumpicker');

        return {
            restrict: 'E',
            scope: {
                soort: '<?' //todo: format e.d.
            },
            require: '?ngModel',
            link: function ($scope, el, attrs, ngModel) {
                $scope.$sihwng = sihwAngularConfig.opties('datatable');
                ngModel.$render = function () {
                    let val = angular.copy(ngModel.$viewValue); //kopie want we willen pas bij de echte change filteren
                    if (!val) {
                        val = {van: null, tot: null};
                        ngModel.$setViewValue(angular.copy(val));
                    }

                    $scope.m = val;
                    maakTitle(); //titel aanpassen
                };

                $scope.filterGewijzigd = function () {
                    //aanpassen dus, als we zover zijn
                    ngModel.$setViewValue(angular.copy($scope.m)); //weer een kopie
                    maakTitle();
                };

                function maakTitle() {
                    //maak een title obv de viewValue
                    let opties = sihwAngularConfig.opties('datepicker');
                    let format = (opties && opties.momentFormat) || "DD-MM-YYYY";
                    let val = ngModel.$viewValue;
                    if (!(val && (val.van || val.tot))) {
                        $scope.title = "";
                        return;
                    }

                    let van = val.van && moment(`${val.van} 00:00`);
                    let tot = val.tot && moment(`${val.tot} 00:00`);

                    if (van && tot) {
                        $scope.title = `${van.format(format)} - ${tot.format(format)}`;
                    } else if (van) {
                        $scope.title = `${$scope.$sihwng.filterVan || 'van'} ${van.format(format)}`;
                    } else {
                        $scope.title = `${$scope.$sihwng.filterTM || 't/m'} ${tot.format(format)}`;
                    }
                }
            },
            template: `
        <div class="datatabledatumpicker" title="{{title}}">
            <div class="form-group">
                <datepicker ng-model="m.van" placeholder="{{$sihwng.filterVan || 'van'}}" ng-change="filterGewijzigd()" stringdate></datepicker>
             </div>
             <div class="form-group">
                <datepicker ng-model="m.tot" na-of-gelijk="m.van" placeholder="{{$sihwng.filterTM || 't/m'}}" ng-change="filterGewijzigd()"  stringdate></datepicker>
             </div>
        </div>
        `
        }
    }]).directive('datatablevantotpicker', ['sihwAngularConfig', 'sihwlog', function (sihwAngularConfig, sihwlog) {
    //filter voor de datatable. Gebruikt sihw-control decimaalveld
    //verwacht wel bootstrap
    let log = sihwlog.logLevel(sihwAngularConfig.loglevel('datatable'));
    log.debug('datatablevantotpicker');

    return {
        restrict: 'E',
        scope: {
            soort: '<?' //todo: format e.d.
        },
        require: '?ngModel',
        link: function ($scope, el, attrs, ngModel) {
            $scope.$sihwng = sihwAngularConfig.opties('datatable');
            ngModel.$render = function () {
                let val = angular.copy(ngModel.$viewValue); //kopie want we willen pas bij de echte change filteren
                if (!val) {
                    val = {van: null, tot: null};
                    ngModel.$setViewValue(angular.copy(val));
                }

                $scope.m = val;
                maakTitle(); //titel aanpassen
            };

            $scope.filterGewijzigd = function () {
                //aanpassen dus, als we zover zijn
                ngModel.$setViewValue(angular.copy($scope.m)); //weer een kopie
                maakTitle();
            };

            /**
             * Kan het niet beter andersom?
             */
            $scope.omdraaien = function () {
                if ($scope.m.van !== null && $scope.m.tot !== null && $scope.m.van > $scope.m.tot) {
                    //omdraaien
                    let t = $scope.m.tot;
                    $scope.m.tot = $scope.m.van;
                    $scope.m.van = t;
                    $scope.filterGewijzigd();
                }
            };

            function maakTitle() {
                //maak een title obv de viewValue
                let val = ngModel.$viewValue;
                if (!val) {
                    $scope.title = "";
                    return;
                }

                let van = val.van;
                if (van === false || van === undefined) {
                    van = null;
                }
                let tot = val.tot;
                if (tot === false || tot === undefined) {
                    tot = null;
                }

                if (van === null && tot === null) {
                    $scope.title = "";
                } else if (van !== null && tot !== null) {
                    $scope.title = `${van} - ${tot}`;
                } else if (van !== null) {
                    $scope.title = `${van}+`;
                } else {
                    $scope.title = `-${tot}`;
                }
            }
        },
        template: `
        <div class="datatablevantotpicker" title="{{title}}">
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="{{$sihwng.filterVan || 'van'}}" decimaal-veld signed minDecimalen="0" maxDecimalen="2" ng-model="m.van" ng-change="filterGewijzigd()" ng-blur="omdraaien()">
                </div>             
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="{{$sihwng.filterTM || 't/m'}}"  decimaal-veld signed minDecimalen="0" maxDecimalen="2" ng-model="m.tot" ng-change="filterGewijzigd()" ng-blur="omdraaien()">
                </div>
        </div>
        `
    }
}
]).directive('datatablemultipicker', ['sihwAngularConfig', 'sihwlog',
    function (sihwAngularConfig, sihwlog) {
        //simpele multiple-select voor het filter
        let log = sihwlog.logLevel(sihwAngularConfig.loglevel('datatable'));
        log.debug('datatablemultipicker');

        return {
            restrict: 'E',
            scope: {
                items: '<?'
            },
            require: '?ngModel',
            link: function ($scope, el, attrs, ngModel) {
                $scope.$watch('items', function (nieuw, vorige) {
                    setItemlist();
                    //en viewval goedzetten
                    setViewval();
                }, true);

                function setItemlist() {
                    let viewval = ngModel.$viewValue;
                    if (!Array.isArray(viewval)) {
                        viewval = viewval ? [viewval] : [];
                    }

                    //value moet case-onafhankelijk uniek zijn, dus daar checken we op
                    $scope.itemlist = [];
                    for (let item of $scope.items || []) {
                        item = item || "-"; //leeg
                        if (!$scope.itemlist.some(gevonden => gevonden.value === item.toLowerCase())) {
                            $scope.itemlist.push({
                                label: item,
                                value: item.toLowerCase(),
                                infilter: viewval.includes(item.toLowerCase())
                            })
                        }
                    }
                }

                function setViewval() {
                    $scope.itemlist = $scope.itemlist || [];
                    let infilter = $scope.itemlist.filter(item => item.infilter);
                    ngModel.$setViewValue(infilter.map(item => item.value));
                    if (infilter.length === 1) {
                        //precies 1: afbeelden
                        $scope.selectie = infilter[0].label;
                    } else if (infilter.length === 0 || infilter.length === $scope.itemlist.length) {
                        $scope.selectie = "";
                    } else {
                        $scope.selectie = `${infilter.length} / ${$scope.itemlist.length}`;
                    }
                }

                $scope.toggleItem = function (event, item) {
                    event.stopPropagation();
                    item.infilter = !item.infilter;
                    setViewval();
                };

                //opvangen dropdown
                let dropdownMenu;
                let origposition;
                let origparent;
                $(el).on('show.bs.dropdown', e => {
                    dropdownMenu = dropdownMenu || $(e.target).find('.dropdown-menu');
                    dropdownMenu.css('display', 'block');
                    origparent = origparent || dropdownMenu.parent();
                    origposition = dropdownMenu.position();
                    let offset = dropdownMenu.offset();
                    $('body').append(dropdownMenu.detach());
                    dropdownMenu.offset(offset);
                    //z-index bepalen: de z-index van de buitenste offsetparent van onze parent
                    //want daar moeten we boven komen
                    //maar ook boven de zindex-dropdown die via
                    //bootstrap wordt gezet

                    let parent = origparent;
                    let zindex = 0;
                    let prev;
                    let i = 0;
                    do {
                        let css = parent.css('z-index');
                        if ((!css) || css === 'auto') {
                            zindex = 0;
                        } else {
                            zindex = parseInt(parent.css('z-index'), 10);
                            if (isNaN(zindex)) {
                                zindex = 0;
                            }
                        }
                        prev = parent;
                        parent = parent.offsetParent();
                    } while (parent && parent.length && (!parent.is(':root')) && (!prev.is(parent)) && i++ < 1000);
                    zindex = Math.max(parseInt(dropdownMenu.css('z-index'), 0) || 0, zindex);
                    dropdownMenu.css('z-index', zindex + 1);
                });

                $(el).on('hide.bs.dropdown', doeClose);
                $scope.close = doeClose;

                function doeClose() {
                    if (!dropdownMenu) {
                        return;
                    }
                    origparent.append(dropdownMenu.detach());
                    dropdownMenu.css({
                        'top': origposition.top,
                        'left': origposition.left,
                        'display': 'none'
                    });
                    $(el).find('.dropdown').removeClass('open');
                }
            },
            template: `
                <div class="dropdown">
                    <button type="button" class="btn btn-default dropdown-toggle"
                            data-toggle="dropdown"><span class="header">{{selectie}}</span><span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu datatablemultipicker_dropdown" ng-mouseleave="close()">
                        <li data-stopPropagation="true" ng-repeat="item in itemlist">
                            <a ng-click="toggleItem($event,item)"><span class="glyphicon"
                                                                        ng-class="{'glyphicon-ok': item.infilter, 'empty': ! item.infilter}"></span>
                                {{item.label}}</a>
                        </li>
                    </ul>
                </div>
            `
        };
    }
]);
